var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgLogout = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.699 14.6992C17.599 14.6992 17.499 14.6992 17.399 14.5992C17.199 14.3992 17.199 14.0992 17.399 13.8992L18.999 12.0992C19.199 11.8992 19.499 11.8992 19.699 12.0992C19.899 12.2992 19.899 12.5992 19.699 12.7992L17.999 14.5992C17.999 14.6992 17.899 14.6992 17.699 14.6992Z",
    fill: "url(#logout_paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3994 12.9008C19.2994 12.9008 19.0994 12.8008 18.9994 12.7008L17.2994 10.9008C17.0994 10.7008 17.0994 10.4008 17.2994 10.2008C17.4994 10.0008 17.7994 10.0008 17.9994 10.2008L19.6994 12.0008C19.8994 12.2008 19.8994 12.5008 19.6994 12.7008C19.5994 12.9008 19.4994 12.9008 19.3994 12.9008Z",
    fill: "url(#logout_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3996 12.9023H15.5996C15.2996 12.9023 15.0996 12.7023 15.0996 12.4023C15.0996 12.1023 15.2996 11.9023 15.5996 11.9023H19.3996C19.6996 11.9023 19.8996 12.1023 19.8996 12.4023C19.8996 12.7023 19.6996 12.9023 19.3996 12.9023Z",
    fill: "url(#logout_paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H5C4.4 19 4 18.5 4 18V6C4 5.4 4.5 5 5 5H15C15.6 5 16 5.5 16 6V18C16.1 18.5 15.6 19 15 19Z",
    fill: "url(#logout_paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 19.7987L5 18.9987C4.4 18.9987 4 18.5987 4 18.0987V6.09874C4 5.49874 4.5 4.99874 5.1 5.09874L13 5.89874C13.5 5.99874 13.9 6.39874 13.9 6.89874V18.7987C14 19.3987 13.5 19.8987 12.9 19.7987Z",
    fill: "url(#logout_paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9004 13.6008V11.2008C11.9004 11.0008 12.1004 10.8008 12.3004 10.8008C12.5004 10.8008 12.7004 11.0008 12.7004 11.2008V13.6008C12.7004 13.8008 12.5004 14.0008 12.3004 14.0008C12.1004 14.0008 11.9004 13.8008 11.9004 13.6008Z",
    fill: "url(#logout_paint5_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint0_linear",
    x1: 13.9006,
    y1: 13.1302,
    x2: 17.5537,
    y2: 13.2852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint1_linear",
    x1: 13.978,
    y1: 11.3165,
    x2: 17.6311,
    y2: 11.4715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint2_linear",
    x1: 13.9378,
    y1: 12.2712,
    x2: 17.5909,
    y2: 12.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint3_linear",
    x1: 4,
    y1: 11.998,
    x2: 16.0589,
    y2: 11.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint4_linear",
    x1: 15.3572,
    y1: 7.44054,
    x2: 1.0989,
    y2: 18.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logout_paint5_linear",
    x1: 12.0963,
    y1: 10.6567,
    x2: 12.5391,
    y2: 14.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9,
    height: 14.9,
    fill: "white",
    transform: "translate(4 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Logout.b85e2309.svg";
export { ForwardRef as ReactComponent };